import { Navigate, useLocation } from "react-router";
import { useSelector } from "react-redux";

import { BASE_PATH_PREFIX } from "../constants/routes";
import { getPostLoginReturnUrl } from "../utils/postLoginRedirect";
import ExternalRedirect from "./ExternalRedirect";

const PublicRoute = ({ children, allowAuthenticated = false }) => {
    const { userData } = useSelector(state => state.auth);
    const location = useLocation();
    const isLoggedIn = userData?.UserId;

    if (!isLoggedIn || allowAuthenticated) return children;

    const returnUrl = getPostLoginReturnUrl(location.search);
    if (returnUrl) return <ExternalRedirect to={returnUrl} />;

    const redirectPath = location.state?.from?.pathname || BASE_PATH_PREFIX;
    return <Navigate to={redirectPath} replace />;
};

export default PublicRoute
